import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, Stack } from '@mui/material';

// Assets
import { ReactComponent as IconMaple } from 'Assets/logo-maple-full.svg';
import { ReactComponent as SyrupScreenshot } from 'Assets/screenshot-syrup.svg';
import { ReactComponent as SyrupScreenshotLogoSyrup } from 'Assets/screenshot-syrup-logo-syrup.svg';
import { ReactComponent as SyrupScreenshotLogoMaple } from 'Assets/screenshot-syrup-logo-maple.svg';

// Components
import MapleDialog from 'Components/ds/MapleDialog';
import MapleTypography from 'Components/ds/MapleTypography';
import MapleButton from 'Components/ds/MapleButton';
import MapleIcon from 'Components/ds/MapleIcon';

// Hooks
import useBreakpoint from 'Hooks/useBreakpoint';

// Styles
const componentWrapperStyles = {
  backgroundColor: 'background.weak',
  margin: '0 auto',
  overflow: 'hidden',
  width: '100vw',
  minHeight: '100vh',
};
const imageWrapperStyles = {
  position: 'relative',
  backgroundColor: theme => theme.palette.background.weak,
  borderRadius: theme => theme.shape.md,
  height: '220px',
  '@keyframes fadeOutSyrup': {
    '0%': {
      opacity: 1,
      transform: 'translateX(-50%)',
    },
    '100%': {
      opacity: 0,
      transform: 'translateX(calc(-50% - 20px))',
    },
  },
  '@keyframes fadeInMaple': {
    '0%': {
      opacity: 0,
      transform: 'translateX(calc(-50% - 20px))',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(-50%)',
    },
  },
};
const logoWrapperStyles = {
  position: 'absolute',
  bottom: '-5px',
  left: '50%',
  transform: 'translateX(-50%)',
};

const RedirectPage: FC = () => {
  const { isDesktopDevice } = useBreakpoint();
  const iconMapleSize = isDesktopDevice ? { width: 128, height: 40 } : { width: 96, height: 30 };
  return (
    <Box sx={componentWrapperStyles}>
      <MapleDialog open={true} disableClose>
        <Stack spacing={3}>
          <Stack spacing={2.5} alignItems='center' width='100%'>
            <MapleTypography
              variant='h4'
              component='h1'
              fontWeight='normal'
              align='center'
              sx={{
                svg: {
                  xs: { transform: 'translateY(8px)', marginLeft: '4px' },
                  md: { transform: 'translateY(10px)', marginLeft: '4px' },
                },
              }}
            >
              Syrup has moved to <IconMaple {...iconMapleSize} />
            </MapleTypography>
            <Stack direction='row' alignItems='center' spacing={1} mt={2}>
              <MapleIcon icon='checkCircleFill' color='#3FC07C' />
              <MapleTypography size='medium' color='success.dark'>
                Your yield and positions stay the same
              </MapleTypography>
            </Stack>
          </Stack>
          <Stack alignItems='center' justifyContent='flex-end' sx={imageWrapperStyles}>
            <SyrupScreenshot />
            <Box
              sx={{
                ...logoWrapperStyles,
                animation: 'fadeOutSyrup 1s ease forwards',
                animationDelay: '1s',
              }}
            >
              <SyrupScreenshotLogoSyrup />
            </Box>
            <Box
              sx={{
                ...logoWrapperStyles,
                opacity: 0,
                animation: 'fadeInMaple 1s ease forwards',
                animationDelay: '1.2s',
              }}
            >
              <SyrupScreenshotLogoMaple />
            </Box>
          </Stack>
          <Link to='https://app.maple.finance/earn' style={{ textDecoration: 'none', width: '100%' }}>
            <MapleButton fullWidth variant='contained' endIcon={<MapleIcon icon='arrowRight' color='#FFFFFF' />}>
              <MapleTypography paddingRight={2}>Go to app.maple.finance/earn</MapleTypography>
            </MapleButton>
          </Link>
        </Stack>
      </MapleDialog>
    </Box>
  );
};

export default RedirectPage;
